import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { MultiSelect } from 'primereact/multiselect';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getCurrentCompany, getStyle, SERVICE_FLEET, SERVICE_WORKSHOP, SERVICE_CHAIN, styleMerge, TYPE_CARE_SERVICE, TYPE_WORKSHOP_ALL } from '../../../utils/utils';
import { fetchGarages as _fetchGarages } from '../../../actions/garageActions';
import {
  fetchTasks as _fetchTasks,
  deleteTask as _deleteTask,
  setTaskStatus as _setTaskStatus,
} from '../../../actions/taskActions';
import CBPromptModal from '../../shared/CBPromptModal';
import TaskListItem from './TaskListItem';
import VehicleListTh from '../../OrganizationGarageView/OrganizationGarageComponents/VehicleListTh';
import CBMobileSortSelect from '../../shared/CBMobileSortSelect';
import TaskFilterBar from './TaskFilterBar';
import CBSelectFilters from '../../shared/CBSelectFilters';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import AddTaskModal from './AddTaskModal';
import { selectWorkshopChain as _selectWorkshopChain } from '../../../actions/workshopActions';
import { withRouter } from 'react-router-dom';
import { Paginator } from 'primereact/paginator';
import { fetchVehiclesByOrganization as _fetchVehiclesByOrganization, fetchVehiclesForCareService as _fetchVehiclesForCareService } from '../../../actions/vehicleActions';
import { fetchChainCareServiceVehicles as _fetchChainCareServiceVehicles } from '../../../actions/chainActions';
import { companySwitchState, listStateKey, loadListState, saveListState } from '../../../utils/listState';



class TaskListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      addTaskModalIsOpen: false,
      deleteModalIsOpen: false,
      search: '',
      ordering: 'priority',
      filters: {
        status: 'created'
      },
      fields: [],
      selectedFields: [],
      selectedTasks: [],
      page: 1,
    };
    this.tableScrollRef = React.createRef();
    this.topScrollRef = React.createRef();
    this._isSyncingScroll = false;
  }

  componentDidMount() {
    this.syncTopScrollWidth();
    if (typeof ResizeObserver !== 'undefined' && this.tableScrollRef.current) {
      this._resizeObserver = new ResizeObserver(this.syncTopScrollWidth);
      this._resizeObserver.observe(this.tableScrollRef.current);
    }
  }

  componentWillUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  syncTopScrollWidth = () => {
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      var inner = this.topScrollRef.current.firstChild;
      if (inner) {
        inner.style.width = this.tableScrollRef.current.scrollWidth + 'px';
      }
    }
  };

  handleTopScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      this.tableScrollRef.current.scrollLeft = this.topScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  handleTableScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.topScrollRef.current && this.tableScrollRef.current) {
      this.topScrollRef.current.scrollLeft = this.tableScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  componentWillMount() {
    const {
      fetchGarages,
      t,
      fetchTasks,
      service,
      selectedWorkshopId,
      selectedOrganizationId,
      selectedChainId,
      location,
      fetchVehiclesByOrganization,
      fetchVehiclesForCareService,
      fetchChainCareServiceVehicles,
    } = this.props;

    const selectedFields = JSON.parse(localStorage.getItem('selectedTaskFields'));

    const allFields = [
      {
        label: t('headingRegistrationNumber'),
        value: 'vehicle_registration_number',
      },
      {
        label: t('headingPriority'),
        value: 'priority',
      },
      {
        label: t('headingTitle'),
        value: 'title',
      },
      {
        label: t('headingVisibility'),
        value: 'visibility_display',
      },
      {
        label: t('headingStatus'),
        value: 'status',
      },
      {
        label: t('headingCompanyAndGarage'),
        value: 'organization',
      },
      {
        label: t('headingUserDisplay'),
        value: 'user_display',
      },
      {
        label: t('headingEmployee'),
        value: 'employee',
      },
      {
        label: t('headingOrigin'),
        value: 'origin',
      },
      {
        label: t('headingDueAt'),
        value: 'due_at',
      },
    ];

    if (this.getCurrentCompany().use_vehicle_identifier) {
      allFields.splice(1, 0, {
        label: t('headingVehicleIdentifier'),
        value: 'vehicle_identifier',
      })
    }

    this.setState({
      fields: allFields,
    });

    this.setState({
      selectedFields: selectedFields || this.getDefaultFields(),
    });

    let overrideOrganization = null;
    // Check URL parameters for opening modal
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('openAddTask') === 'true') {
      if (location.pathname.includes('all/')) {
        overrideOrganization = 'all';
      }
      this.setState({ addTaskModalIsOpen: true });
    }

    fetchGarages();
    if (service === SERVICE_WORKSHOP) {
      fetchVehiclesForCareService(selectedWorkshopId, {ordering: 'registration_number'});
    } else if (service === SERVICE_FLEET) {
      fetchVehiclesByOrganization(selectedOrganizationId, { ordering: 'registration_number' });
    } else if (service === SERVICE_CHAIN && selectedChainId) {
      fetchChainCareServiceVehicles(selectedChainId, { ordering: 'registration_number' });
    }

    // Load saved list state per company before initial fetch
    const savedState = this.loadListStateFromStorage();
    if (savedState) {
      const { search, ordering: savedOrdering, filters, page } = savedState;
      this.setState({
        search: search || '',
        ordering: savedOrdering || this.state.ordering,
        filters: filters || this.state.filters,
        page: page || 1,
      }, () => {
        this.refetchTasks(savedOrdering || this.state.ordering, filters || this.state.filters, overrideOrganization, page || this.state.page, true);
      });
    } else {
      this.refetchTasks(null, null, overrideOrganization);
    }
  }

  changePage = (e) => {
    const newPage = e.page + 1;
    this.setState({
      page: newPage,
    }, () => {
      this.saveListStateToStorage();
      this.refetchTasks(null, null, null, newPage);
    });
  };

  getDefaultFields = () => {
    let defaultFields =  [
      'vehicle_registration_number',
      'priority',
      'title',
      'visibility_display',
      'status',
      'organization',
      'user_display',
      'employee',
      'origin',
      'due_at'
    ];

    if (this.getCurrentCompany().use_vehicle_identifier) {
      defaultFields.push('vehicle_identifier');
    }

    return defaultFields;
  }

  getCurrentCompany = () => {
    const {
      user,
      selectedOrganizationId,
      selectedWorkshopId,
      selectedChainId
    } = this.props;

    return getCurrentCompany(user, selectedOrganizationId, selectedWorkshopId, selectedChainId) || {};
  }

  setSelectedFields = (newSelectedFields) => {
    this.setState({
      selectedFields: newSelectedFields,
    });
    JSON.stringify(newSelectedFields);
    localStorage.setItem('selectedTaskFields', JSON.stringify(newSelectedFields));
  }

  getCompanyScopeKey = () => {
    const { service, selectedWorkshopId, selectedOrganizationId, selectedChainId } = this.props;
    if (service === SERVICE_WORKSHOP) {
      return listStateKey('taskListState', 'workshop', selectedWorkshopId);
    }
    if (service === SERVICE_FLEET) {
      return listStateKey('taskListState', 'organization', selectedOrganizationId);
    }
    if (service === SERVICE_CHAIN) {
      // componentDidUpdate reloads on a chain switch, so the chain has to be in
      // the key — otherwise every chain shares one entry.
      return listStateKey('taskListState', 'chain', selectedChainId);
    }
    return listStateKey('taskListState', 'unknown', null);
  }

  saveListStateToStorage = () => {
    const { search, ordering, filters, page } = this.state;
    saveListState(this.getCompanyScopeKey(), { search, ordering, filters, page });
  }

  loadListStateFromStorage = () => loadListState(this.getCompanyScopeKey())

  getGarage = () => {
    const { garages, garageId } = this.props;
    return garages.find(garage => garage.id == garageId);
  }

  getSelectedTasks = () => {
    const { selectedTasks } = this.state;
    const { tasks } = this.props;

    return tasks.filter((msg) => selectedTasks.includes(msg.id));
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
    this.refetchGarageTasks();
  };

  closeUpdateModal = () => {
    this.setState({
      updateModalIsOpen: false,
    });
  };

  openAddTaskModal = () => {
    this.setState({
      addTaskModalIsOpen: true,
    });
  };

  closeAddTaskModal = () => {
    this.setState({
      addTaskModalIsOpen: false,
    });
  };

  closeDeletePromptModal = () => {
    this.setState({
      deleteModalIsOpen: false,
    });
  };

  afterOpenModal = () => {
  };

  selectVehicle = (taskId) => {
    const { selectedTasks } = this.state;

    const newSelectedTasks = selectedTasks.slice();

    newSelectedTasks.push(taskId);
    this.setState({ selectedTasks: newSelectedTasks });
  };

  unselectVehicle = (taskId) => {
    const { selectedTasks } = this.state;

    const newSelectedTasks = selectedTasks.filter((item) => item !== taskId);

    this.setState({ selectedTasks: newSelectedTasks });
  };

  updateTasks = () => {
    this.setState({ updateModalIsOpen: true });
  };

  sendTasks = () => {
    this.setState({ addTaskModalIsOpen: true });
  };

  deleteTasks = () => {
    this.setState({ deleteModalIsOpen: true });
  };

  changeSearchTerms = value => {
    this.setState({
      search: value,
    }, () => {
      this.saveListStateToStorage();
    });
  }

  changeFilterTerms = value => {
    this.setState({
      filters: value,
      page: 1, // Reset to page 1 when filters change
    }, () => {
      this.saveListStateToStorage();
      this.refetchTasks(null, value, null, 1);
    });
  }

  refetchTasks = (newOrdering = null, newFilters = null, overrideOrganization = null, newPage = null, isRestored = false) => {
    const { fetchTasks, garageId, service, selectedWorkshopId, selectedOrganizationId, selectedChainId, selectedWorkshopChainId } = this.props;
    const { search, ordering, filters, page } = this.state;

    const params = {
      search,
      ordering: newOrdering || ordering,
      garage_id: garageId
    };

    // Only force page 1 if we're not restoring saved state and there are actual changes
    if (!isRestored && (newFilters || newOrdering)) {
      params.page = 1
    } else {
      params.page = newPage || page;
    }

    if (service === SERVICE_WORKSHOP && selectedWorkshopChainId) {
      params.chain_id = selectedWorkshopChainId;
    }

    fetchTasks(
      newFilters ? { ...newFilters, ...params } : { ...filters, ...params },
      service === SERVICE_WORKSHOP && selectedWorkshopId,
      service === SERVICE_FLEET && (overrideOrganization || selectedOrganizationId),
      service === SERVICE_CHAIN && selectedChainId,
    );

    this.saveListStateToStorage();
  };

  changeOrdering = (clickedOrdering) => {
    const { ordering } = this.state;
    let newOrdering;
    if (ordering === clickedOrdering) {
      newOrdering = `-${ordering}`;
    } else if (`-${ordering}` === clickedOrdering) {
      newOrdering = 'id';
    } else {
      newOrdering = clickedOrdering;
    }
    this.setState({
      ordering: newOrdering,
      page: 1, // Reset to page 1 when ordering changes
    }, () => {
      this.saveListStateToStorage();
      this.refetchTasks(newOrdering, null, null, 1);
    });
  };

  getOrderingSymbol = (columnName) => {
    const { ordering } = this.state;
    if (ordering === columnName) {
      return '/img/down_arrow_icon.svg';
    } else if (ordering === `-${columnName}`) {
      return '/img/up_arrow_icon.svg';
    }
    return undefined;
  };

  selectAllTasks = () => {
    const { tasks } = this.props;

    const newSelectedTasks = tasks.map((task) => task.id);
    this.setState({ selectedTasks: newSelectedTasks });
  };

  unselectAllTasks = () => {
    this.setState({ selectedTasks: [] });
  };

  selectAllChanged = () => {
    const { tasks } = this.props;
    const { selectedTasks } = this.state;
    const allChecked = selectedTasks.length === tasks.length;

    if (allChecked) {
      this.unselectAllTasks();
    } else {
      this.selectAllTasks();
    }
  }

  componentDidUpdate(prevProps) {
    this.syncTopScrollWidth();
    const { selectedWorkshopId, selectedWorkshopChainId, selectedOrganizationId, selectedChainId, service } = this.props;

    if (selectedWorkshopChainId !== prevProps.selectedWorkshopChainId) {
      this.setState({ page: 1 }, () => this.refetchTasks());
      return;
    }

    if (selectedWorkshopId != prevProps.selectedWorkshopId
      || selectedOrganizationId != prevProps.selectedOrganizationId
      || selectedChainId != prevProps.selectedChainId
      || service != prevProps.service) {
      // A company with no saved state of its own starts clean: keeping the
      // previous company's search and filters would both show the wrong list
      // and — since refetchTasks persists what it sent — write them into the new
      // company's entry (see utils/listState).
      const savedState = this.loadListStateFromStorage();
      const nextState = companySwitchState(savedState, this.state.ordering);
      this.setState(nextState, () => {
        this.refetchTasks(nextState.ordering, nextState.filters, null, nextState.page, !!savedState);
      });
    }
  }

  applyOrdering = (newOrdering) => {
    this.setState({ ordering: newOrdering, page: 1 }, () => {
      this.saveListStateToStorage();
      this.refetchTasks(newOrdering, null, null, 1);
    });
  };

  getSortableFields = () => {
    const { t } = this.props;
    var fields = [];
    if (this.getCurrentCompany().use_vehicle_identifier) {
      fields.push({ label: t('headingVehicleIdentifier'), field: 'vehicle_identifier' });
    }
    fields.push({ label: t('headingPriority'), field: 'priority' });
    fields.push({ label: t('headingTitle'), field: 'title' });
    fields.push({ label: t('headingCompanyAndGarage'), field: 'organization__name' });
    fields.push({ label: t('headingUserDisplay'), field: 'user__profile__first_name' });
    fields.push({ label: t('headingOrigin'), field: 'origin' });
    fields.push({ label: t('headingDueAt'), field: 'due_at' });
    return fields;
  };

  renderTaskItems = () => {
    const {
      tasks,
      removeVehicleFromGarage,
      deleteTask,
      setTaskStatus,
      service,
      selectedWorkshopId,
      selectedChainId,
    } = this.props;
    const { selectedTasks, selectedFields } = this.state;
    const garage = this.getGarage();
    return tasks.map(task => (
      <TaskListItem
        selectedFields={selectedFields}
        task={task}
        key={task.id}
        garage={garage}
        selected={selectedTasks.includes(task.id)}
        removeVehicleFromGarage={removeVehicleFromGarage}
        select={this.selectVehicle}
        unselect={this.unselectVehicle}
        deleteTask={deleteTask}
        setTaskStatus={setTaskStatus}
        service={service}
        selectedWorkshopId={selectedWorkshopId}
        selectedChainId={selectedChainId}
        useVehicleIdentifier={this.getCurrentCompany().use_vehicle_identifier}
      />
    ));
  };

  render() {
    const {
      tasks,
      t,
      removeVehicleFromGarage,
      user,
      deleteTask,
      setTaskStatus,
      service,
      selectedWorkshopId,
      selectedChainId,
      careServiceVehicles,
      garageVehicles,
      chainCareServiceVehicles,
      pagination,
    } = this.props;

    const {
      selectedTasks,
      addTaskModalIsOpen,
      deleteModalIsOpen,
      filters
    } = this.state;

    const { modalIsOpen, fields, selectedFields } = this.state;
    const garage = this.getGarage();

    const vehicles = service === SERVICE_CHAIN ? chainCareServiceVehicles : (service === SERVICE_WORKSHOP ? careServiceVehicles : garageVehicles);

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'topBarsContainer')}>
              <TaskFilterBar
                useIdentifiers={this.getCurrentCompany().use_vehicle_identifier}
                changeSearchTerms={this.changeSearchTerms}
                changeFilterTerms={this.changeFilterTerms}
                refetchTasks={this.refetchTasks}
                addTask={this.openAddTaskModal}
                filters={filters}
                search={this.state.search}
              />
              {(function () {
                var ws = user && user.workshops && user.workshops.find(function (w) { return w.id == selectedWorkshopId; });
                if (service === SERVICE_WORKSHOP && ws && ws.workshop_chains && ws.workshop_chains.length > 1) {
                  return (
                    <div style={{ padding: '4px 16px' }}>
                      <CBSelectFilters
                        name='chain_filter'
                        options={[{ value: '', label: t('filterAllChains') }].concat(
                          ws.workshop_chains.map(function (c) { return { value: String(c.id), label: c.name }; })
                        )}
                        onChange={function (changed) {
                          this.props.selectWorkshopChain(changed.chain_filter ? parseInt(changed.chain_filter) : null);
                        }.bind(this)}
                        value={this.props.selectedWorkshopChainId ? String(this.props.selectedWorkshopChainId) : ''}
                        selectStyle={{ marginLeft: 0, marginRight: 0, width: 200 }}
                      />
                    </div>
                  );
                }
                return null;
              }).call(this)}
              <hr style={{ opacity: '30%' }} />
            </div>

            {screenSize === 'small' ? (
              <div style={getStyle(screenSize, styles, 'mobileListContainer')}>
                <CBMobileSortSelect
                  fields={this.getSortableFields()}
                  ordering={this.state.ordering}
                  onChange={this.applyOrdering}
                />
                {this.renderTaskItems()}
                {pagination && (
                  <Paginator
                    first={(pagination.page_size * pagination.current_page - 1)}
                    rows={pagination.page_size}
                    totalRecords={pagination.count}
                    onPageChange={this.changePage}
                  />
                )}
              </div>
            ) : (
            <React.Fragment>
            <div
              ref={this.topScrollRef}
              onScroll={this.handleTopScroll}
              style={getStyle(screenSize, styles, 'topScrollbar')}
              className="vehicle-table-scrollbar"
            >
              <div style={getStyle(screenSize, styles, 'topScrollbarInner')} />
            </div>
            <div
              ref={this.tableScrollRef}
              onScroll={this.handleTableScroll}
              style={getStyle(screenSize, styles, 'tableContainer')}
              className="vehicle-table-scrollbar"
            >
              <table style={getStyle(screenSize, styles, 'table')}>
                <thead>
                  <tr>
                    <th style={styleMerge(getStyle(screenSize, styles, 'tableHeaderFirst'), getStyle(screenSize, styles, 'alignCenter'))}>
                      <CBLabelAndCheckbox
                        checked={selectedTasks.length === tasks.length}
                        additionalStyles={{ justifyContent: 'center' }}
                        onChange={this.selectAllChanged}
                      />
                    </th>

                    {
                      selectedFields.includes('vehicle_identifier') && this.getCurrentCompany().use_vehicle_identifier && (
                        <VehicleListTh
                          text={t('headingVehicleIdentifier')}
                          fieldName='vehicle_identifier'
                          orderingSymbol={this.getOrderingSymbol('vehicle_identifier')}
                          changeOrdering={() => {
                            this.changeOrdering('vehicle_identifier');
                          }}
                        />
                      )
                    }

                    <VehicleListTh
                      text={t('headingRegistrationNumber')}
                      fieldName='vehicle_registration_number'
                      orderingSymbol={this.getOrderingSymbol('vehicle_registration_number')}
                      changeOrdering={() => {
                        this.changeOrdering('vehicle_registration_number');
                      }}
                      notSortable
                    />

                    {
                      selectedFields.includes('priority') && (
                        <VehicleListTh
                          text={t('headingPriority')}
                          fieldName='priority'
                          orderingSymbol={this.getOrderingSymbol('priority')}
                          changeOrdering={() => {
                            this.changeOrdering('priority');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('title') && (
                        <VehicleListTh
                          text={t('headingTitle')}
                          fieldName='title'
                          orderingSymbol={this.getOrderingSymbol('title')}
                          changeOrdering={() => {
                            this.changeOrdering('title');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('visibility_display') && (
                        <VehicleListTh
                          text={t('headingVisibility')}
                          fieldName='visibility_display'
                          orderingSymbol={this.getOrderingSymbol('visibility_display')}
                          changeOrdering={() => {
                            this.changeOrdering('visibility_display');
                          }}
                          notSortable
                        />
                      )
                    }

                    {
                      selectedFields.includes('status') && (
                        <VehicleListTh
                          text={t('headingStatus')}
                          fieldName='status'
                          orderingSymbol={this.getOrderingSymbol('status')}
                          changeOrdering={() => {
                            this.changeOrdering('status');
                          }}
                          notSortable
                        />
                      )
                    }

                    {
                      selectedFields.includes('organization') && (
                        <VehicleListTh
                          text={t('headingCompanyAndGarage')}
                          fieldName='organization'
                          orderingSymbol={this.getOrderingSymbol('organization__name')}
                          changeOrdering={() => {
                            this.changeOrdering('organization__name');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('user_display') && (
                        <VehicleListTh
                          text={t('headingUserDisplay')}
                          fieldName='user_display'
                          orderingSymbol={this.getOrderingSymbol('user__profile__first_name')}
                          changeOrdering={() => {
                            this.changeOrdering('user__profile__first_name');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('employee') && (
                        <VehicleListTh
                          text={t('headingEmployee')}
                          fieldName='employee'
                          orderingSymbol={this.getOrderingSymbol('employee')}
                          changeOrdering={() => {
                            this.changeOrdering('employee');
                          }}
                          notSortable
                        />
                      )
                    }

                    {
                      selectedFields.includes('origin') && (
                        <VehicleListTh
                          text={t('headingOrigin')}
                          fieldName='origin'
                          orderingSymbol={this.getOrderingSymbol('origin')}
                          changeOrdering={() => {
                            this.changeOrdering('origin');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('due_at') && (
                        <VehicleListTh
                          text={t('headingDueAt')}
                          fieldName='due_at'
                          orderingSymbol={this.getOrderingSymbol('due_at')}
                          changeOrdering={() => {
                            this.changeOrdering('due_at');
                          }}
                        />
                      )
                    }

                    <th></th>


                    <th style={getStyle(screenSize, styles, 'tableHeaderSettings')}>
                      <MultiSelect
                        value={selectedFields}
                        onChange={(e) => this.setSelectedFields(e.value)}
                        options={fields}
                        className="bars"
                        dropdownIcon={undefined}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderTaskItems()}
                </tbody>
              </table>
              {
                pagination && (
                  <Paginator
                    first={(pagination.page_size * pagination.current_page - 1)}
                    rows={pagination.page_size}
                    totalRecords={pagination.count}
                    onPageChange={this.changePage}
                  />
                )
              }
            </div>
            </React.Fragment>
            )}
            {addTaskModalIsOpen && (
              <AddTaskModal
                modalIsOpen={addTaskModalIsOpen}
                closeModal={this.closeAddTaskModal}
                vehicles={vehicles}
              />
            )}
            {deleteModalIsOpen && (
              <CBPromptModal
                modalIsOpen={deleteModalIsOpen}
                closeModal={this.closeDeletePromptModal}
                afterOpenModal={() => {}}
                title={t('deleteManyFromGaragePromptTitle')}
                text={`${t('deleteManyFromGaragePromptText')}`}
                buttonText={t('deleteButton')}
                performAction={() => {
                  deleteTask();
                  this.closeDeletePromptModal();
                  this.unselectAllTasks();
                }}
              />
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      width: '100%',
      padding: '0px 16px 0px 0px',
    },
    mobileListContainer: {
      padding: '0 16px 24px 16px',
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
    searchContainer: {
      maxWidth: 600,
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '24px',
      paddingBottom: 16,
      position: 'relative',
    },
    table: {
      whiteSpace: 'nowrap',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    topScrollbar: {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%',
      marginTop: 12,
    },
    topScrollbarInner: {
      height: 1,
    },
    tableHeader: {
      fontFamily: 'TitilliumWeb-Bold',
      color: '#FFFFFF',
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      padding: '8px 8px 8px 8px',
    },
    tableHeaderSettings: {
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      //position: 'sticky',
      padding: '8px 8px 8px 8px',
      right: 0,
    },
    tableHeaderFirst: {
      //position: 'sticky',
      left: 0,
    },
    alignCenter: {
      textAlign: 'center',
    },
    topBarsContainer: {
      marginTop: 32,
      paddingLeft: 16,
    },
  },
  medium: {
    table: {
    },
  },
  small: {
    table: {
    },
    container: {
      padding: 0,
    },
    topBarsContainer: {
      paddingRight: 16,
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    garages: state.garage.garages,
    tasks: state.task.tasks,
    pagination: state.task.pagination,
    service: state.app.service,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedWorkshopChainId: state.workshop.selectedWorkshopChainId,
    selectedOrganizationId: state.organization.selectedOrganization,
    selectedChainId: state.chain.selectedChainId,
    careServiceVehicles: state.vehicle.careServiceVehicles,
    garageVehicles: state.vehicle.garageVehicles,
    chainCareServiceVehicles: state.chain.chainCareServiceVehicles,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchGarages: _fetchGarages,
    fetchTasks: _fetchTasks,
    deleteTask: _deleteTask,
    setTaskStatus: _setTaskStatus,
    fetchVehiclesByOrganization: _fetchVehiclesByOrganization,
    fetchVehiclesForCareService: _fetchVehiclesForCareService,
    fetchChainCareServiceVehicles: _fetchChainCareServiceVehicles,
    selectWorkshopChain: _selectWorkshopChain,
  },
)(withRouter(translate('TaskListView')(TaskListView)));
